import { TextHTwoIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Heading2 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextHTwoIcon size={Sizes[size]} {...rest} color={fill} />;
};

Heading2.displayName = 'Heading2';
